import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import Axios from "axios";
import CONFIG from "../model/TSConfig";
import getErrorMessage from "../utils/error_handling/getErrorMessage";

export const fetchManagedAccounts = async (
  masterToken: string
): Promise<ManagedAccount[] | string> => {
  const res = await Axios({
    method: "GET",
    url: `${CONFIG.saasBackendUrl}/customers/allAccounts`,
    headers: { Authorization: `Bearer ${masterToken}` }
  });

  if (res.data.code) {
    return getErrorMessage(res.data.code);
  }

  return res.data;
};
